import React from "react";
import {
  FaArrowLeft,
  FaBars,
  FaAngleRight,
  FaCar,
  FaMotorcycle,
  FaHome,
  FaBuilding,
  FaTruck,
  FaBus,
  FaTractor,
  FaSolarPanel,
} from "react-icons/fa";
import * as SCREENS from "../constants/screens";

import FarmIcon from "../assets/icons/farm.svg";
import LandIcon from "../assets/icons/land.svg";
import JetSkiIcon from "../assets/icons/jetski.svg";
import { useBlueBody } from "../hooks/useBlueBody";

export default function Finality({ dataManager, sidebarManager }) {
  const { data, setData, sendDataToSheet } = dataManager;
  const { openSidebar } = sidebarManager;
  useBlueBody();

  function prevScreen() {
    const screen = data.redirected ? SCREENS.NAME : SCREENS.ADMINISTRATORS;
    setData({ ...data, screen: screen });
  }

  function nextScreen(finality, category) {
    sendDataToSheet(
      data.name,
      data.phone,
      data.associateMode,
      data.redirected,
      data.administrator,
      `${data.name} quer crédito para ${finality}`
    );

    setData({
      ...data,
      finality: finality,
      category: category,
      screen: SCREENS.CREDIT,
    });
  }

  return (
    <section className="administrators-screen">
      <div className="container mb-5">
        <div className="row justify-content-between align-items-center">
          <div className="col-auto">
            <FaArrowLeft
              role="button"
              className="icon-bar"
              onClick={prevScreen}
            />
          </div>
          <div className="col-8">
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: "40%" }}
                role="progressbar"
                aria-label="Progress Bar"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div className="col-auto">
            <FaBars role="button" className="icon-bar" onClick={openSidebar} />
          </div>
        </div>
      </div>
      <div className="container mb-5">
        <h1>Olá, {data.name}!</h1>
        <h2>Qual a finalidade do crédito desejado?</h2>
      </div>
      <div className="bottom-panel container">
        <div className="row row-custom-padding">
          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Carro", 2)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <FaCar className="icon-card" />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Carro</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Moto", 1)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <FaMotorcycle className="icon-card" />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Moto</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Casa", 4)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <FaHome className="icon-card" />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Casa</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Apartamento", 4)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <FaBuilding className="icon-card" />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Apartamento</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Terreno", 4)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <img
                    src={LandIcon}
                    className="icon-card"
                    alt="Icone para representar terreno"
                  />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Terreno</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Fazenda", 2)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <img
                    src={FarmIcon}
                    className="icon-card"
                    alt="Icone para representar fazenda"
                  />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Fazenda</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("JetSki", 1)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <img
                    src={JetSkiIcon}
                    className="icon-card"
                    alt="Icone para representar jetski"
                  />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>JetSki</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Caminhão", 3)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <FaTruck className="icon-card" />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Caminhão</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Ônibus", 3)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <FaBus className="icon-card" />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Ônibus</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Trator", 3)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <FaTractor className="icon-card" />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Trator</strong>
              </p>
            </div>
          </div>

          <div className="col-6 col-md-4 d-flex">
            <div
              className="card card-body card-results text-dark mb-2"
              role="button"
              tabIndex="0"
              onClick={(e) => nextScreen("Energia Solar", 2)}
              onKeyDown={(e) => e.target.onClick}
            >
              <div className="row justify-content-between mb-2">
                <div className="col">
                  <FaSolarPanel className="icon-card" />
                </div>
                <div className="col-auto">
                  <FaAngleRight className="hire-results" />
                </div>
              </div>
              <p className="mt-auto mb-0">
                <strong>Energia Solar</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
